import { useNavigate, useParams } from "react-router-dom";
import { useGetProductAttributes } from "./hooks/useGetProductAttributes";
import { transformAttributeToTreeViewItem } from "./utils";
import { useMemo } from "react";
import Box from "@mui/material/Box";
import { TreeView } from "../components/TreeView/Treeview";
import { AttributeContent } from "./AttributeContent";
import { AttributePlaceholder } from "./AttributePlaceholder";
import { useAttributeMatch } from "./hooks/useAttributeMatch";
import { TreeItem } from "../components/TreeView/types";

export const AttributesPage = () => {
  const navigate = useNavigate();

  const { isLoading, productAttributes, flattenedProductAttributes } =
    useGetProductAttributes();

  const { matchedProductAttribute } = useAttributeMatch(
    flattenedProductAttributes
  );

  const treeViewItems = useMemo<TreeItem[]>(() => {
    return productAttributes?.map(transformAttributeToTreeViewItem) || [];
  }, [productAttributes]);

  const { attributeId } = useParams<{ attributeId: string }>();

  return (
    <Box display="flex" gap={1} height="100%">
      <Box width={370} sx={{ overflowY: "auto" }}>
        <TreeView
          id="product-attribute-tree"
          inputText="Search for Product Attribute"
          isLoading={isLoading}
          items={treeViewItems}
          onClick={({ id }) => {
            navigate(`/catalog/product/attribute/${id}`);
          }}
        />
      </Box>

      <Box width="1px" bgcolor="divider" height="100%" />

      <Box flex={1} sx={{ overflowY: "auto" }}>
        {attributeId ? (
          <AttributeContent
            matchedProductAttribute={
              matchedProductAttribute || {
                id: 0,
                name: "unknown",
                level: 0,
                description: null,
              }
            }
            isLoading={isLoading}
          />
        ) : (
          <AttributePlaceholder />
        )}
      </Box>
    </Box>
  );
};
